import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AccountInformation } from "src/app/interfaces/account-information";
import { ApiResponse } from "src/app/interfaces/api-response";
import { MenuItem } from "src/app/interfaces/menuItem";
import { AccountService } from "src/app/services/account.service";
import { ApplicationService } from "src/app/services/application.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: "app-mobile-navigation",
    templateUrl: "./mobile-navigation.component.html",
    styleUrls: ["./mobile-navigation.component.scss"],
    standalone: false
})
export class MobileNavigationComponent implements OnInit {
  @Output()
  gotoItemEvent: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();
  @Output()
  closeMenuEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() browseGroups: MenuItem[];
  @Input() menuItems: MenuItem[];
  @Input() settingsItems: MenuItem[];
  isPartnerPortal: boolean;
  accountInformation: AccountInformation;

  constructor(public applicationService: ApplicationService, private accountService: AccountService, private helperService: HelperService) {
    this.isPartnerPortal = this.applicationService.isPartnerPortal();
  }

  ngOnInit(): void {
    this.getAccountInformation();
  }

  gotoItem(menuItem: MenuItem) {
    this.gotoItemEvent.emit(menuItem);
  }

  closeMenu() {
    this.closeMenuEvent.emit(true);
  }

  getAccountInformation() {
    return this.accountService
      .getAccountInformation(true)
      .then((accountInformation: AccountInformation) => {
        this.accountInformation = accountInformation;
      });
  }

  gotoRakoo() {
    this.accountService.getRakooUrl().subscribe((apiResponse: ApiResponse) => {
      if (this.helperService.checkResponse(apiResponse)) {
        window.open(apiResponse.result,"_blank");
      }
    })
  }

  getRakooLearningUrl() {
    this.accountService.getRakooLearningUrl().subscribe((apiResponse: ApiResponse) => {
      if (this.helperService.checkResponse(apiResponse)) {
        window.open(apiResponse.result,"_blank");
      }
    })
  }
}
